import { COMPANY_ROLES } from '@/constants/userRoles.js'

const getRoleIsCompanyRole = (role) => {
  return COMPANY_ROLES.includes(role)
}

export default getRoleIsCompanyRole
